export default class ArenaSeat {
    PlaceCode: number = 0;
    LineName: string = '';
    PlaceName: string = '';
    X: number = 0;
    Y: number = 0;
    TariffCode: number = 0;
    IsFree: boolean = false;
}